import React from "react"
import Navbar from "./Navbar"
// import Footer from './Footer'
import ".././assets/css/committee.css"
import Footer from "./Footer"
const Committee = () => {
  return (
    <div>
      <Navbar />
      <div className="committeewrap">
        <div className="Page-title">
          <h3 className="title-subheading">Organizing Committee</h3>
          <div className="names">
            <h4>CHIEF-PATRON</h4>
            Prof. S. Sundar Manoharan,
            <br />
            Director General, PDEU
          </div>
          <div className="names">
            <h4>PATRONS</h4>
            Prof. Anirbid B Sircar,
            <br />
            Director, SOET, PDEU
            <br />
            <p></p>
            Prof. Dhaval Pujara,
            <br />
            Director SOT, PDEU
          </div>
          <div className="names">
            <h4>CHAIRS</h4>
            Dr. Uttam Kumar Bhui,
            <br />
            HOD PE, SOET, PDEU
            <br />
            <p></p>
            Dr. Bhawanisingh Desai, <br />
            Dean R & D, PDEU
          </div>
          <div className="names">
            <h4>CONVENER</h4>
            Dr. Rohit Srivastava,
            <br />
            SOET, PDEU
          </div>
          <div className="names">
            <h4>CO-CONVENER</h4>
            Dr. Achinta Bera,
            <br />
            SOET, PDEU
          </div>
          <div className="names">
            <h4>TREASURERS</h4>
            Dr. Balasubramanian Ragunathan,
            <br />
             SOET, PDEU
           <br />
            Dr. Hari Sreenivasan
            <br />
            SOET, PDEU
            <br />
            Mr. Hari Pavan Sriram Yalamati
            <br />
            SOET, PDEU
          </div>

        </div>

        <div className="subheading">
          <h3>INTERNATIONAL ADVISORY COMMITTEE</h3>
          <div className="subheading-details">
            Dr. A.M. Kannan, <br />
            <h3 className="committe-location">Arizona State University, USA</h3>
          </div>
          <div className="subheading-details">
          Dr. Marta Duenas Diez, <br />
            <h3 className="committe-location">LIFTE H2, Boston, USA</h3>
          </div>
          <div className="subheading-details">
            Dr. Bishnu  P Bastakoti, <br />
            <h3 className="committe-location">North Carolina Agriculture and Technical State University, USA</h3>
          </div>
          <div className="subheading-details">
            Dr. Neha Chaturvedi <br />
            <h3 className="committe-location">North Carolina State University, USA</h3>
          </div>
          <div className="subheading-details">
            Dr. Pei Meng <br />
            <h3 className="committe-location">Universiti Malaya, Malaysia</h3>
          </div>
          <div className="subheading-details">
            Prof. Daewon Pak, <br />
            <h3 className="committe-location">Seoul National University of Science and Technology, South Korea</h3>
          </div>
          <div className="subheading-details">
            Dr. Diogo M.F Santos, <br />
            <h3 className="committe-location">Instituto Superior Tecnico, Portuagal</h3>
          </div>
          <div className="subheading-details">
            Dr. Mahesh Gangishetty, <br />
            <h3 className="committe-location">Mississippi State University, USA</h3>
          </div>
          <div className="subheading-details">
            Prof. Japan Trivedi <br />
            <h3 className="committe-location">University of Alberta, Canada</h3>
          </div>
          <div className="subheading-details">
            Prof. Ryosuke Okuno, <br />
            <h3 className="committe-location">
              The University of Texas at Austin, USA
            </h3>
          </div>
          {/* <div className="subheading-details">
            Prof. Pravin Linga, <br />
            National University of Singapore, SG
          </div> */}
          <div className="subheading-details">
            Prof. Stefan Iglauer, <br />
            <h3 className="committe-location">
              Edith Cowan University, Australia
            </h3>
            <div className="subheading-details">
              Prof. Deepak Dubal, <br />
              <h3 className="committe-location">
                Queensland University of Technology, Brisbane, Australia
              </h3>
            </div>
            <div className="subheading-details">
              Prof. Dmitry Yakhvarov, <br />
              <h3 className="committe-location">
                A.E ARbuzov institute of Organic and Physical Chemistry, Kazan,
                Russia
              </h3>
            </div>
          </div>
          {/* <div className="subheading-details">
            Dr. Hussein Hoteit, <br />
            KAUST, Kingdom of Saudi Arabia
          </div> */}
        </div>

        <div className="subheading">
          <h3>NATIONAL ADVISORY COMMITTEE </h3>
          {/* <div className="subheading-details">
            Dr. Anirbid B Sircar, <br />
            <h3 className="committe-location">Director, SOET, PDEU</h3>
          </div> */}
          <div className="subheading-details">
            Prof. Arnab Dutta, <br />
            <h3 className="committe-location">IIT Bombay</h3>
          </div>
          <div className="subheading-details">
            Prof. D.N. Srivastava, <br />
            <h3 className="committe-location">CSIR-CSMCRI Bhavnagar</h3>
          </div>
          <div className="subheading-details">
            Prof. Anugrah Singh, <br />
            <h3 className="committe-location">IIT Guwahati</h3>
          </div>
          <div className="subheading-details">
            Dr. Jayeeta Chattopadhyay, <br />
            <h3 className="committe-location">Amity University, Ranchi</h3>
          </div>
          <div className="subheading-details">
            Dr. Ajay Kumar, <br />
            <h3 className="committe-location">IIT Tirupati</h3>
          </div>
          <div className="subheading-details">
            Dr. Pankaj Khanna, <br />
            <h3 className="committe-location">IIT Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Arup Mukherjee, <br />
            <h3 className="committe-location">IIT Bhilai</h3>
          </div>
          <div className="subheading-details">
            Dr. Venkata Krishnan, <br />
            <h3 className="committe-location">IIT Mandi</h3>
          </div>
          <div className="subheading-details">
            Dr. Sanyasinaidu Boddu, <br />
            <h3 className="committe-location">INST Mohali</h3>
          </div>
          <div className="subheading-details">
           Dr. Rik Rani Koner, <br />
            <h3 className="committe-location">IIT Mandi</h3>
          </div>
          <div className="subheading-details">
            Dr. Aditi Halder, <br />
            <h3 className="committe-location">IIT Mandi</h3>
          </div>
          <div className="subheading-details">
            Dr. Tarun Kumar Naiya, <br />
            <h3 className="committe-location">IIT(ISM) Dhanbad</h3>
          </div>
          <div className="subheading-details">
            Prof. Tarun Gupta, <br />
            <h3 className="committe-location">IIT kanpur</h3>
          </div>
          <div className="subheading-details">
          Dr. Debasish Das, <br />
            <h3 className="committe-location"> IISc Bangalore</h3>
          </div>
          <div className="subheading-details">
          Dr. Samrat Gupta, <br />
            <h3 className="committe-location"> IIM Ahmedabad</h3>
          </div>
          <div className="subheading-details">
          Dr. Jay Singh, <br />
            <h3 className="committe-location"> BHU Varanasi</h3>
          </div>
          <div className="subheading-details">
          Prof. N.C Pradhan, <br />
            <h3 className="committe-location">  IIT Kharagpur</h3>
          </div>
          <div className="subheading-details">
          Prof. S.K Maity, <br />
            <h3 className="committe-location"> IIT Hyderabad</h3>
          </div>
          {/* <div className="subheading-details">
          Mr. Balaiha Swamy, <br />
            <h3 className="committe-location"> Indian Oil Corporation Ltd </h3>
          </div>
          <div className="subheading-details">
          Mr. C.H Seeta Ram, <br />
            <h3 className="committe-location">  Bharat Petroleum Corporation Ltd </h3>
          </div> */}
        </div>

        <div className="subheading">
          <h3>LOCAL ADVISORY COMMITTEE</h3>
          <div className="subheading-details">
            Prof. Tarun Shah, <br />
            <h3 className="committe-location">Registrar, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Prof. Anirbid B Sircar, <br />
            <h3 className="committe-location">Director SOET, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Prof. T.P Singh, <br />
            <h3 className="committe-location">Dean Student Affairs, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Prof. Surendra Singh Kachhwaha, <br />
            <h3 className="committe-location">Dean SOT, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Bhawanisingh Desai, <br />
            <h3 className="committe-location">Dean R&D, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Praghnesh Bhatt, <br />
            <h3 className="committe-location">Dean SOET, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Vishvesh J Badheka, <br />
            <h3 className="committe-location">Dean Academic Affairs, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Rajesh Patel, <br />
            <h3 className="committe-location">Dean Admission, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Prof. R.K.Vij, <br />
            <h3 className="committe-location">Dean of Placements, PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Prof. Ranjan Sengupta, <br />
            <h3 className="committe-location">PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Ramesh Guduru, <br />
            <h3 className="committe-location">PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Nitin Chaudhari,
            <br />
            <h3 className="committe-location">PDEU Gandhinagar</h3>
          </div>
          <div className="subheading-details">
            Dr. Abhijit D Ray,
            <br />
            <h3 className="committe-location">PDEU Gandhinagar</h3>
          </div>
        </div>

        <div className="subheading-2">
          <h3>ORGANIZING COMMITTEE </h3>
          <div className="subheading-details-2">Dr. Rohit Srivastava</div>
          <div className="subheading-details-2">Dr. Achinta Bera</div>
          <div className="subheading-details-2">Dr. Vivek Ramalingam</div>
          <div className="subheading-details-2">Dr. Amit Verma</div>
          <div className="subheading-details-2">Dr. Paul Naveen</div>
          <div className="subheading-details-2">Dr. Balanagalu Basupalli</div>
          <div className="subheading-details-2">Dr. Abhishek Kumar Gupta</div>
          <div className="subheading-details-2">Dr. Ankur Solanki</div>
          <div className="subheading-details-2">Dr. Hepzibah Mary</div>
          <div className="subheading-details-2">Dr. Rajat Saxena</div>
          <div className="subheading-details-2">Dr. Himanshu Choksi</div>
          <div className="subheading-details-2">Mr. Gaurav Hazarika</div>
          <div className="subheading-details-2">Dr. Lakshmann Rao Jeeru</div>
          <div className="subheading-details-2">Dr. Hari Sreenivasan</div>
          <div className="subheading-details-2">Dr. Balasubramanian Ragunathan</div>
          <div className="subheading-details-2">Dr. Shanker Krishna</div>
          <div className="subheading-details-2">Dr. Maunish Shah</div>
          <div className="subheading-details-2">Dr. Namrata Bist</div>
          <div className="subheading-details-2">Dr. Akash Patel</div>
          <div className="subheading-details-2">Dr. Kaushal Kishor</div>
          <div className="subheading-details-2">Dr. Amrita Chakraborty</div>
        </div>

        <div className="subheading-2">
          <h3>SCHOLARS/STUDENTS ORGANIZING COMMITTEE </h3>
          <div className="subheading-details-2">Ms. Avni Goswami</div>
          <div className="subheading-details-2">Ms. Sneha Lavate</div>
          <div className="subheading-details-2">Mr. Hari Pavan Sriram Yalamati</div>
          <div className="subheading-details-2">Mr. Isaac Wilson</div>
          <div className="subheading-details-2">Mr. Anuj Jain</div>
          <div className="subheading-details-2">Ms. Chaandini JP</div>
          <div className="subheading-details-2">Mr. Shubham Nayak</div>
          <div className="subheading-details-2">Mr. Anshul</div>
          <div className="subheading-details-2">Mr. Kiran B</div>
          <div className="subheading-details-2">Mr. Shaikh Fazeel</div>
        </div>
      </div>

      {/* </div> */}
      <Footer />
    </div>
  )
}

export default Committee
